export default "__VITE_ASSET__703a20e6__"